import bulmaQuickview from "bulma-quickview/dist/js/bulma-quickview.min.js";
import "bulma-quickview/dist/css/bulma-quickview.min.css";
import "bulma-quickview/dist/js/bulma-quickview.min.js";

document.addEventListener("turbolinks:load", () => {
  bulmaQuickview.attach();
});